module.exports = __webpack_public_path__ + "media/meow_3.19231ad9.wav";